import { sessionFieldsQuery } from './getSession'
import { gql } from './gql'

/**
 * `validate: false` does **not** mean "skip authorisation". The flag selects
 * *where the customer is resolved from*: `false` routes resolution through the
 * storefront's `CREATE_SESSION` add-on, which asks the client's own system to
 * authorise the store code (and the optional phone riding in `customFields`).
 * The literal `false` reads backwards at the call site, which is why this
 * constant exists (scoping doc, workstream 4).
 */
export const RESOLVE_CUSTOMER_VIA_ADD_ON = false

/**
 * The store code is always the identifier — a phone is only ever an
 * additional credential, never the lookup key (scoping doc, out of scope:
 * "login by phone as an alternative identifier").
 */
export const VALIDATE_BY_STORE_CODE = 'code'

/**
 * Creates — or, for a repeated store code, **reuses** — the shopper's session.
 *
 * Reuse is the API's intended behaviour, not a bug: the same code returns the
 * same session with its cart and checkout selections intact.
 *
 * `data` is a `SessionInput`, but its `type` field must never be sent: on the
 * reuse path the update assigns `session.customer = { type }`, wiping the
 * code, customFields and creditAmount that identify the shopper to the
 * checkout-rule endpoints. `CreateSessionData` omits the field so the mistake
 * does not type-check.
 */
export const CREATE_SESSION = gql`
  mutation CreateSession(
    $storefrontName: String!
    $data: SessionInput!
  ) {
    createSession(storefrontName: $storefrontName, data: $data) {
      ${sessionFieldsQuery}
    }
  }
`
